import React from 'react'
import HeaderOnboarding from './components/Header/HeaderOnboarding/HeaderOnboarding'
import { Col, Container, Row } from 'react-bootstrap'
import page404 from './assets/images/page404.svg'
import './ErrorBoundary.scss'
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    if (
      error?.name === 'ChunkLoadError' ||
      error?.message?.includes('Loading chunk') ||
      error?.message?.includes('ChunkLoadError')
    ) {
      console.warn('ChunkLoadError detected. Reloading application...')
      window.location.reload(true) // hard refresh
      return
    }

    // Log error to state
    this.setState({ error, errorInfo })
    // Send error to backend for logging
    this.logErrorToService(error, errorInfo)
  }

  logErrorToService = async (error, errorInfo) => {
    const hostname = window.location.hostname
    let BASE_URL = ''

    if (hostname === 'exitfund.com') {
      BASE_URL = 'https://admin-api.exitfund.com'
    } else if (hostname === 'stg.exitfund.com') {
      BASE_URL = 'https://admin-api.stg.exitfund.com'
    } else {
      BASE_URL = 'http://127.0.0.1:7000'
    }

    const errorDetails = {
      errorName: error?.name || 'UnknownError',
      error: error.toString(),
      stack: errorInfo.componentStack,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
    }
    // console.log({ errorDetails })
    try {
      await fetch(`${BASE_URL}/error/frontend-error-logger`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(errorDetails),
      })
    } catch (err) {
      console.error('Failed to send error log to server:')
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <HeaderOnboarding />
          <Container className="errorPage">
            <Row className="align-items-center">
              <Col md={6} xs={12} xs={{ order: 'last' }} md={{ order: 'first' }} className="left">
                <img src={page404} alt="page_404" className="img-fluid" />
              </Col>
              <Col md={6} xs={12} className="right">
                <h1 className="error-x">ERROR</h1>
                <h1 className="title-x">Something Broke</h1>
                <p className="subtitle-x">An unexpected error occurred in the app. Refresh and try again.</p>
              </Col>
            </Row>
          </Container>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
